<template>
  <div class="mx-10 ma-5">
    <v-card flat class="pa-5">
      <div>
        <PageTitleWithSearch
          :title="'Goods Return Note'"
          :btnName="'Create New Goods Return Note'"
          :btnColor="'#00B3FF'"
          :btnRoute="'/goodsReturn/create'"
          :btnPermission="'goods_return_note.create'"
          :btnEnable="true"
          :loading="loading"
          :search="search"
          @searchText="searchChange($event)"
        />

        <DataTableWithPagination
          :headers="headers"
          :items="grnList"
          :loading="loading"
          :page="page"
          :total="total"
          @pageChange="page = $event"
        >
          <template #row="{ item, index }">
            <tr
              :key="item.grn_number"
              :class="[
                { 'first-row': index === 0 },
                index % 2 === 0 ? 'dark-row' : 'light-row',
                'custom-row',
              ]"
              @click="
                hasPermission('goods_return_note.view') && goToGrnDetails(item)
              "
            >
              <td class="text-left">{{ item.goods_return_number }}</td>
              <td class="text-left">
                {{ formatDate(item.goods_return_date, dateFormat) }}
              </td>
              <td class="text-left">{{ item.supplier_name }}</td>
              <td class="text-left">{{ item.branch_name }}</td>
              <td class="text-left">{{ item.reason_for_return }}</td>
              <!-- <td class="text-left">
                <v-btn
                  v-if="hasPermission('goods_return_note.edit')"
                  class="ma-1"
                  color="#FFE0B2"
                  :to="'/goodsReturn/edit/' + item.uuid"
                  fab
                  x-small
                  style="box-shadow: none;"
                >
                  <v-icon small color="#FF9800">mdi-pencil</v-icon>
                </v-btn>
              </td> -->
            </tr>
          </template>
        </DataTableWithPagination>
      </div>
    </v-card>
  </div>
</template>

<script>
import DataTableWithPagination from "@/components/shared/DataTableWithPagination.vue";
import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import { GoodsReturnService } from "@/services/goodsReturn-service.js";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
const { mapGetters: mapSettingsGetters } = createNamespacedHelpers("settings");
import { useDateFormatter } from "../../composables/useDateFormatter.js";

export default {
  name: "GoodsReturnList",
  components: {
    PageTitleWithSearch,
    DataTableWithPagination,
  },
  data() {
    return {
      loading: false,
      search: "",
      grnList: [],
      page: 1,
      total: 0,
      headers: [
        {
          text: "GReturn Number",
          align: "start",
          value: "goods_return_number",
        },
        { text: "date", align: "start", value: "goods_return_date" },
        { text: "supplier_name", align: "start", value: "supplier_name" },
        { text: "Branch", align: "start", value: "branch_name" },
        { text: "reason", align: "start", value: "reason_for_return" },
        // { text: "Actions", align: "start", value: "actions" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
    ...mapSettingsGetters({
      dateFormat: "dateFormat",
    }),
  },
  created() {
    this.fetchGrnList();
  },
  setup() {
    const { formatDate } = useDateFormatter();
    return {
      formatDate,
    };
  },
  watch: {
    search() {
      this.page = 1;
      this.fetchGrnList();
    },
    page() {
      this.fetchGrnList();
    },
  },
  methods: {
    async fetchGrnList() {
      this.loading = true;
      try {
        const response = await GoodsReturnService.getGrnList(
          this.search,
          this.page
        );
        this.grnList = response.data?.data || [];
        this.total = response.data?.meta?.last_page || 0;
      } catch (error) {
        this.grnList = [];
        this.total = 0;
        console.error(
          "Error fetching GRN List:",
          error.response?.data || error.message
        );
      } finally {
        this.loading = false;
      }
    },
    searchChange(event) {
      this.search = event;
    },
    goToGrnDetails(item) {
      this.$router.push({
        name: "GoodsReturnDetails",
        params: { uuid: item.uuid },
      });
    },
    getStatusColor(status) {
      switch (status) {
        case "completed":
          return "green";
        case "pending":
          return "orange";
        default:
          return "grey";
      }
    },
    stringFormatting(status) {
      return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    },
  },
};
</script>
